export default __webpack_public_path__ + "static/image-faq-accordion-929b246f592cbb8c55f5a47b84df32b7.png";